<template>
	<b-container fluid>
		<b-row>
			<b-col sm="12">
				<card>
					<template v-slot:headerTitle>
						<h6 class="card-title">Social media links</h6>
					</template>
					<template v-slot:headerAction>
						<div class="float-right"></div>
					</template>
					<template v-slot:body>
						<b-form @submit.prevent="updateSettings('social')" enctype="multipart/form-data">
							<b-row>
								<b-col md="3" class="form-group">
									<label class="control-label">Facebook</label>
									<b-form-input v-model="facebook" v-bind:class="{ 'is-invalid': Boolean(errors.facebook) }"></b-form-input>
									<div v-for="(val, index) in errors.facebook" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="3" class="form-group">
									<label class="control-label">Twitter</label>
									<b-form-input v-model="twitter" v-bind:class="{ 'is-invalid': Boolean(errors.twitter) }"></b-form-input>
									<div v-for="(val, index) in errors.twitter" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="3" class="form-group">
									<label class="control-label">Instagram</label>
									<b-form-input v-model="instagram" v-bind:class="{ 'is-invalid': Boolean(errors.instagram) }"></b-form-input>
									<div v-for="(val, index) in errors.instagram" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="2">
									<b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
								</b-col>
							</b-row>
						</b-form>
					</template>
				</card>
				<card>
					<template v-slot:headerTitle>
						<h6 class="card-title">Version control</h6>
					</template>
					<template v-slot:headerAction>
						<div class="float-right"></div>
					</template>
					<template v-slot:body>
						<b-form @submit.prevent="updateSettings('version')" enctype="multipart/form-data">
							<b-row>
								<b-col md="3" class="form-group">
									<label class="control-label">Android</label>
									<b-form-input v-model="android_version" v-bind:class="{ 'is-invalid': Boolean(errors.android) }"></b-form-input>
									<div v-for="(val, index) in errors.android" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="3" class="form-group">
									<label class="control-label">IOS</label>
									<b-form-input v-model="ios_version" v-bind:class="{ 'is-invalid': Boolean(errors.ios) }"></b-form-input>
									<div v-for="(val, index) in errors.ios" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="2">
									<b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
								</b-col>
							</b-row>
						</b-form>
					</template>
				</card>
				<card>
					<template v-slot:headerTitle>
						<h6 class="card-title">Maintenance mode</h6>
					</template>
					<template v-slot:headerAction>
						<div class="float-right"></div>
					</template>
					<template v-slot:body>
						<b-form @submit.prevent="updateSettings('maintenance')">
							<b-row>
								<b-col md="3" class="form-group">
									<label class="control-label">Maintenance</label>
									<select v-model="maintenance" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance) }">
										<option value="0">No</option>
										<option value="1">Yes</option>
									</select>
									<div v-for="(val, index) in errors.maintenance" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="6" class="form-group">
									<label class="control-label">Reason for maintenance</label>
									<b-form-input v-model="maintenance_reason" v-bind:class="{ 'is-invalid': Boolean(errors.reason) }"></b-form-input>
									<div v-for="(val, index) in errors.reason" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="3">
									<b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
								</b-col>
							</b-row>
						</b-form>
					</template>
				</card>
				<card>
					<template v-slot:headerTitle>
						<h6 class="card-title">Admin details</h6>
					</template>
					<template v-slot:headerAction>
						<div class="float-right"></div>
					</template>
					<template v-slot:body>
						<b-form @submit.prevent="updateSettings('admin')">
							<b-row>
								<b-col md="4" class="form-group">
									<label class="control-label">Name</label>
									<b-form-input v-model="name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
									<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>

								<b-col md="4" class="form-group">
									<label class="control-label">Email</label>
									<b-form-input v-model="email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
									<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="3">
									<b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
								</b-col>
							</b-row>
						</b-form>
					</template>
				</card>
				<card>
					<template v-slot:headerTitle>
						<h6 class="card-title">Change password</h6>
					</template>
					<template v-slot:headerAction>
						<div class="float-right"></div>
					</template>
					<template v-slot:body>
						<b-form @submit.prevent="updateSettings('password')">
							<b-row>
								<b-col md="5" class="form-group">
									<label class="control-label">Password</label>
									<b-form-input type="password" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
									<div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>

								<b-col md="5" class="form-group">
									<label class="control-label">Confirm Password</label>
									<b-form-input type="password" v-model="confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
									<div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="2">
									<b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
								</b-col>
							</b-row>
						</b-form>
					</template>
				</card>

				<card>
					<template v-slot:headerTitle>
						<h6 class="card-title">Ads Approval</h6>
					</template>
					<template v-slot:headerAction>
						<div class="float-right"></div>
					</template>
					<template v-slot:body>
						<b-form @submit.prevent="updateSettings('auto_approval')">
							<b-row>
								<b-col md="3" class="form-group">
									<label class="control-label">Auto Approval</label>
									<select v-model="auto_approval" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.auto_approval) }">
										<option value="0">No</option>
										<option value="1">Yes</option>
									</select>
									<div v-for="(val, index) in errors.auto_approval" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								
								<b-col md="3">
									<b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
								</b-col>
							</b-row>
						</b-form>
					</template>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>
<script>
	export default {
		name: "SettingsPage",
		data() {
			return {
				android_version: null,
				ios_version: null,
				facebook: "",
				twitter: "",
				instagram: "",
				name: "",
				email: "",
				maintenance: null,
				maintenance_reason: "",
				password: "",
				confirm_password: "",
				auto_approval: null,
				token: "",
				errors: {},
			};
		},

		created() {
			this.fetchSettings();
		},

		methods: {
			fetchSettings(page_url = null) {
				this.getToken();
				let url = "/api/admin/settings";
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;

						this.android_version = responseData.android_version;
						this.ios_version = responseData.ios_version;
						this.facebook = responseData.facebook;
						this.twitter = responseData.twitter;
						this.instagram = responseData.instagram;
						this.name = responseData.admin_name;
						this.email = responseData.admin_email;
						this.maintenance = responseData.maintenance;
						this.maintenance_reason = responseData.maintenance_reason;
						this.auto_approval = responseData.auto_approval;

						console.log(responseData);
					})
					.catch((err) => console.log(err));
			},

			getToken() {
				if (localStorage.token) {
					this.token = localStorage.token;
				} else {
					this.$vToastify.error("Session expired, please login again");
					this.$router.push({ name: "auth.login" });
				}
			},
			updateSettings(param) {
				this.getToken();
				let formData = new FormData();
				let url = "";
				if (param == "social") {
					formData.append("facebook", this.facebook);
					formData.append("twitter", this.twitter);
					formData.append("instagram", this.instagram);

					url = "/api/admin/settings/update_media";
				} else if (param == "version") {
					formData.append("android", this.android_version);
					formData.append("ios", this.ios_version);

					url = "/api/admin/settings/update_version";
				} else if (param == "maintenance") {
					formData.append("maintenance", this.maintenance);
					formData.append("reason", this.maintenance_reason);

					url = "/api/admin/settings/update_maintenance";
				} else if (param == "admin") {
					formData.append("name", this.name);
					formData.append("email", this.email);

					url = "/api/admin/settings/update_username";
				} else if (param == "password") {
					formData.append("password", this.password);
					formData.append("password_confirmation", this.confirm_password);

					url = "/api/admin/settings/update_password";
				} else if (param == "auto_approval") {
					formData.append("status", this.auto_approval);
					url = "/api/admin/settings/update_approval_mode";
				}

				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$vToastify.success(response.data.message);
						} else {
							this.$vToastify.error(response.data.message);
						}
						this.fetchSettings();
						this.clearForm();
						if (param == "password") {
							this.password = "";
							this.confirm_password = "";
						}
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$vToastify.error(error.response.message);
							} else {
								this.$vToastify.error("Error!");
							}
						} else {
							this.$vToastify.error("Error!");
						}
					});
			},
			clearForm() {
				this.errors = {};
			},
		},
	};
</script>
